<div>
  <img class="logo" src="/assets/images/as_socialpals_logo_orange.svg" />
  <h1>
    <p>{{ "static.brandEmailConnectionCompletedTitle" | translate }}</p>
    <p>{{ "static.brandEmailConnectionCompletedSubTitle" | translate }}</p>
  </h1>
</div>
